// extracted by mini-css-extract-plugin
export default {"container":"BJntlo","shareButtons":"jGmgRW","flexContainer":"FdoFE4","stats":"ejEA1m","comments":"NH5R2X"};